import Vue from 'vue'
import Cookies from 'js-cookie'
import Store from '@/store'

const BjTokenKey = 'Public-Token'
const SzTokenKey = 'token'
const TokenType = 'tokenType'

export function getErpDomain() {
  const domain = window.document.domain
  const findIndex = process.env.VUE_APP_SZ_SUPPLY.split(',').findIndex(item => {
    return item.indexOf(domain) >= 0
  })
  if (findIndex >= 0) {
    return process.env.VUE_APP_BJ_SUPPLY.split(',')[findIndex]
  } else if (domain.indexOf('-bi.qizhishangke.com') >= 0) {
    return `https://${domain.replace(new RegExp('-bi'), '')}`
  }
  return ''
}

export function getToken() {
  const domain = window.document.domain
  const findIndex = process.env.VUE_APP_SZ_SUPPLY.split(',').findIndex(item => {
    return item.indexOf(domain) >= 0
  })
  if (findIndex >= 0 || domain.indexOf('-bi.qizhishangke.com') >= 0) { // 所属供应链
    const BjToken = Cookies.get(BjTokenKey)
    return { token: BjToken, xFrom: 1 }
  } else if (Vue.ls.get(TokenType) === 'gyl') { // 所属经营分析的供应链账号登录
    const SzToken = Vue.ls.get(SzTokenKey)
    return { token: SzToken, xFrom: 2 }
  } else { // // 所属经营分析的经营分析账号登录
    const SzToken = Vue.ls.get(SzTokenKey)
    return { token: SzToken }
  }
}

export function setToken(token, type) {
  Vue.ls.set(SzTokenKey, token)
  Vue.ls.set(TokenType, type)
}

export function removeToken() {
  // Cookies.remove(BjTokenKey, { domain: '.' + document.domain.split('.').slice(-2).join('.') })
  Vue.ls.remove(SzTokenKey)
  Vue.ls.remove(TokenType)
}

// 判断北京路由是否包含当前路由name
export function getBjRouterExists(name) {
  const bjMenuList = Store.state.user.bjMenuList
  return ergodicRouters(bjMenuList, name)
}
function ergodicRouters(menuList, name) {
  for (let i = 0; i < menuList.length; i++) {
    if (menuList[i].name === name) {
      return true
    }
    if (menuList[i].children) {
      if (ergodicRouters(menuList[i].children, name)) {
        return true
      }
    }
  }
  return false
}

export function getAppAutoInfo() {
  const gylLoginData = Vue.ls.get('gylLoginData', {})
  const info = {
    ...gylLoginData,
    [SzTokenKey]: Vue.ls.get(SzTokenKey, null),
    [TokenType]: Vue.ls.get(TokenType, null),
    sid: Vue.ls.get('sid', null),
    account: Vue.ls.get('account', null),
    operatorName: Vue.ls.get('operatorName', null),
  }

  return info
}
